<style type="text/css" media="screen" scoped>
.slider-img{
	width: 211px;
	height: 158px;
	filter: drop-shadow(0px 1px 5px rgba(157, 149, 149, 0.25));
	border-radius: 30px;
}
</style>

<template>
	<div class="pt-0">
		<carousel 
		:per-page="item_per_page" 
		:autoplay="autoplay"  
		:speed="speed" 
		:paginationEnabled="paginationenabled"
		:scrollPerPage="false"
		paginationActiveColor="#1DC895"
		loop
		>
			<slide v-for="(image,i) in slider_images" :key="i"  class="pa-0 flex-basis-max-content bg-white mx-3">
				<img :src="image.image_url" alt="img" class="slider-img  border-a">
			</slide>
		</carousel>
	</div>
</template>
<script type="text/javascript">
import { Carousel, Slide } from 'vue-carousel';

export default {
	props:['slider_images'],
	components: {
		Carousel,
		Slide
	},
	data () {
		return {
			speed:1000,
			paginationenabled:true,
			autoplay:true,
			item_per_page:4,			
		}
	},

}
</script>